import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      const next = sp.get("next") || (u.role === "admin" ? "/admin" : "/");
      nav(next, { replace: true });
    } catch (err) { toast.error(err?.response?.data?.detail || "Login failed"); }
    finally { setBusy(false); }
  };
  return (
    <div className="blz-container py-14 max-w-md">
      <h1 className="font-display text-3xl font-bold">Sign in</h1>
      <p className="text-sm text-slate-500 mt-1">Welcome back to Noyaa Pharma.</p>
      <form onSubmit={submit} className="card-flat p-6 mt-6 space-y-3">
        <label className="block"><span className="text-xs font-semibold">Email</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 w-full h-11 rounded-lg border border-slate-200 px-3" data-testid="login-email"/>
        </label>
        <label className="block"><span className="text-xs font-semibold">Password</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1 w-full h-11 rounded-lg border border-slate-200 px-3" data-testid="login-password"/>
        </label>
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit">{busy ? "Signing in..." : "Sign in"}</button>
      </form>
      <div className="text-sm mt-4 flex justify-between">
        <Link to="/register" className="text-emerald-700 font-semibold">Create an account</Link>
        <Link to="/forgot-password" className="text-slate-500">Forgot password?</Link>
      </div>
    </div>
  );
}
